import React from "react";

import { templates } from "@reactivated";

import { LocatorSendSingleStoreSSR } from "../apps/retail-locator/LocatorSendSingleStoreSSR";

export const Template = (
    props: templates.LocatorSendStoreDetailsTemplate,
): React.JSX.Element => {
    return <LocatorSendSingleStoreSSR {...props} />;
};
